import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'

/** Shared confirm-before-destructive-action dialog — same look everywhere it's used
 * (Panels, Field copy, and anywhere else a mutation needs a confirm step). */
export function ConfirmDialog({
  title,
  body,
  confirmLabel,
  destructive,
  busy,
  onConfirm,
  onClose,
}: {
  title: string
  body: string
  confirmLabel: string
  destructive?: boolean
  busy: boolean
  onConfirm: () => void
  onClose: () => void
}) {
  return (
    <Dialog open onOpenChange={(next) => !next && !busy && onClose()}>
      <DialogContent showCloseButton={false} className="max-w-sm gap-0 overflow-hidden rounded-lg border border-line-strong bg-popover p-5">
        <span
          className={`pointer-events-none absolute inset-y-0 left-0 w-0.5 ${destructive ? 'bg-danger' : 'bg-warn'}`}
          aria-hidden
        />
        <DialogTitle className="mb-2 text-[14px] font-semibold text-foreground">
          {title}
        </DialogTitle>
        <p className="text-[13px] text-text-2">
          {body}
        </p>
        <div className="mt-4 flex gap-2">
          <Button size="sm" variant={destructive ? 'destructive' : 'default'} disabled={busy} onClick={onConfirm}>
            {busy ? '…' : confirmLabel}
          </Button>
          <Button size="sm" variant="ghost" disabled={busy} onClick={onClose}>
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
